"use strict";

/**
* Строка таблицы.
* 
* @class WebAccess.components.wrappers.form.TableRow
* @extends WebAccess.components.wrappers.form.BaseTableLine
* @property {string} name Имя реквизита
* @property {string} selector Путь в DOM-иерархии к объекту группы, например div.content#container
* @param {string} itemSelector Существующий элемент страницы
*/
(function (global) {

  /**
  * Имя реквизита "Номер строки"
  */
  var ROW_NUMBER = {
    VALUE: L('DETAIL_REQ_NUMBER'),
    DISPLAY_VALUE: 'Field_' + L('DETAIL_REQ_NUMBER')
  }

  var TableRow = global.components.wrappers.form.BaseTableLine.extend({
    className: "TableRow",

    _rowID: null,
    _isNew: false,
    rowNum: -1,
    requisites: {},

    // Событие когда вся строка или колонка проинициализирована, т.к. значения всех реквизитов есть.
    Init: null,
    // Массив Init для каждого реквизита в виде Deffered объектов.
    _reqValuesInit: null,

    init: function (itemSelector, rowNum, rowData, isNew, parentTable, grid) {
      var me = this;
      me._super(itemSelector, parentTable);

      me.Init = $.Deferred();
      me._reqValuesInit = [];

      var rowNumReq = rowData.requisitesData[ROW_NUMBER.VALUE];
      me.name = rowNumReq ? rowNumReq.value : rowNum;
      me.rowNum = rowNumReq ? +rowNumReq.value : +rowNum;

      me.id = me._rowID = +rowData.id;
      me._isNew = isNew;

      me.requisites = new global.components.wrappers.form.RequisiteCollection();
      var reqData = rowData.requisitesData;
      const columns = parentTable.columns;      
      for (var reqName in reqData) {
        if (reqName === 'class') continue;

        var req = me._createRequisite(reqName, reqData[reqName], true, grid);
        req.fullName = me._makeFullName(reqName, me._rowID);
        req._isNew = isNew;

        if (me.isDisabled()) {
          req.disable();
        } else {
          // Если колонка доступна для редактирования, то сделаем текущий реквизит доступным.
          const currentColumn = columns[reqName];
          if (currentColumn && !currentColumn.isDisabled()) {
            req.enable();
          }          
        }

        req.bind(req['class'].EVENT.CHANGE, function () {
          me.fire(me['class'].EVENT.CHANGE);
        });

        me.requisites.addElement(reqName, req);
      }
      me._jDataItems = $('div[name="' + me.name + '"]');

      // _reqValuesInit заполняется в родительском классе requisitesMixin
      $.when.apply(null, me._reqValuesInit).then(function () {
        me.Init.resolve();
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
    * Получает признак, что запись новая
    * @method WebAccess.components.wrappers.form.TableRow#isNew
    * @return {boolean} Признак, что запись новая
    * @since 5.2.0.1300
    */
    isNew: function () {
      return this._isNew;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить ИД строки.
    *
    * @method WebAccess.components.wrappers.form.TableRow#getRowId
    * @since 5.0.0.7100
    * @return {integer} ИД строки детального раздела.
    */
    getRowId: function () {
      return this._rowID;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает значения всех реквизитов для отправки на сервер.
    * @method WebAccess.components.wrappers.form.TableRow#_getActualValues
    * @private
    * @since 5.0.0.7100
    */
    _getActualValues: function () {
      var me = this;
      var tbl = me._parentTable._jObject;
      var row = me._jObject;
      var rowId = me._rowID;

      var res = {};
      var reqs = this.requisites.toArray();
      for (var reqI = 0; reqI < reqs.length; reqI++) {
        var req = reqs[reqI];
        if (req.isChanged() || req.isNew() || (req._data.type === 'pick' && req.isRequired() && req.isRendered())) {
          res[me._makeFullName(req.name, rowId)] = req.getValue();
        }
      };

      //Дополнительные скрытые реквизиты.
      if (row.data('hiddenRequisites')) {
        // Модифицируем отправляемые данные с учетом ИД строк.
        var modHiddReqs = {};
        var hiddReqs = row.data('hiddenRequisites');
        for (var fullReqName in hiddReqs) {
          if (fullReqName.indexOf('$') !== -1) {
            var reqNameParts = fullReqName.split('$');
            if (reqNameParts.length === 3) {
              modHiddReqs[me._makeFullName(reqNameParts[2], rowId)] = hiddReqs[fullReqName];
            }
          }
        };
        $.extend(res, modHiddReqs);
      }

      return res;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удалить строку.
    *
    * @method WebAccess.components.wrappers.form.TableRow#remove
    * @return {WebAccess.components.wrappers.form.TableRow} Объект типа TableRow.
    * @since 5.0.0.7100
    */
    remove: function () {
      this._parentTable.deleteRow(this._rowID, true);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сделать строку недоступной для изменения.
    *
    * @method WebAccess.components.wrappers.form.TableRow#disable
    * @return {WebAccess.components.wrappers.form.TableRow} Объект типа TableRow.
    */
    disable: function () {
      this._super();

      //Блокируем реквизиты в строке.
      let reqs = this.requisites.toArray();
      reqs.forEach((req) => {
        req.disable();
      });

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Делает активным, доступными для изменения все реквизиты строки.
    * @method WebAccess.components.wrappers.form.TableRow#enable
    * @return WebAccess.components.wrappers.form.TableRow
    */
    enable: function () {
      this._super();

      //Разблокируем реквизиты в строке.
      let reqs = this.requisites.toArray();
      reqs.forEach((req) => {
        req.enable();
      });

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить реквизиты записи детального раздела.
    * 
    * @method WebAccess.components.wrappers.form.TableRow#getRequisites
    * @return {WebAccess.components.wrappers.form.RequisiteCollection} Объект типа RequisiteCollection.
    * @since 5.0.0.7100
    */
    getRequisites: function () {
      return this.requisites;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показывает, заполнены ли реквизиты строки, кроме системых.
    * 
    * @method WebAccess.components.wrappers.form.TableRow#hasFilledRequisites
    * @return {boolean} True – заполнены реквизиты строки, кроме системных, иначе – False.
    * @since 5.5.0.1000
    */
    hasFilledRequisites: function () {
      var reqs = this.requisites.toArray();
      return reqs.some(function (req) {
        var reqVal = req.getValue();
        return !req.isSystem() && typeof reqVal !== 'undefined' && reqVal !== '' && reqVal !== null; // 0 - это нормальное значение.
      });
    }

  },
    {
      EVENT: {
        /**
        * Событие срабатывает если данные в строке были изменены.
        *
        * @event WebAccess.components.wrappers.form.TableRow.EVENT.CHANGE
        * @param {object} context ссылка на экземпляр класса
        * @since 5.5.0.2201
        */
        CHANGE: 'change'
        //-------------------------------------------------------------------//
      }
    });

  global.components.wrappers.form.TableRow = TableRow;
})(window.WebAccess);